document.addEventListener('DOMContentLoaded', function() {


  $('.btn-delete-existing-space-image').on('click', function(e){

    if(confirm('Are you sure you want to delete this space image?')){
      let imageId = $(this).data('image-id');
      let thisEel = $(this);

      $.ajax({
        url: '/communal-spaces/deleteImage', 
        method: 'POST',
        data: {
          image_id: imageId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        success: function(response) {

          if(response.success){
            thisEel.parent().remove(); // remove li item..
          }
        }
      })
    }
  });
});